import { z } from "zod";

export const createRoomCategorySchema = z.object({
  name: z.string().min(1, "Category name is required"),

  description: z.string().min(1, "Category description is required"),

  amenities: z
    .array(z.string().min(1, "Amenity must be a string"))
    .nonempty({ error: "You should choose one or more features! " }),

  amenityIcons: z.record(z.string(), z.string()).optional(),

  price: z.string(),

  photoId: z.string().optional(),

  customFeatures: z.array(
    z.object({ value: z.string(), icon: z.string().optional() }),
  ),
});

export type CreateRoomCategoryFormData = z.infer<
  typeof createRoomCategorySchema
>;
